import { FC, ReactNode, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppContext } from "../../context/context";
import { ContextStateType } from "../../context/context.types";

interface AuthorizedRouteProps {
  children: ReactNode;
}

const AuthorizedRoute: FC<AuthorizedRouteProps> = ({ children }) => {
  const location = useLocation();
  const [isAuthorized, setIsAuthorized] = useState(true);

  const { context_state, set_portfolio_by_id, set_account_by_id } =
    useAppContext();

  useEffect(() => {
    const { account, selected_portfolio }: ContextStateType = context_state;

    if (account && account.admin) {
      setIsAuthorized(true);
    } else {
      if (
        selected_portfolio &&
        account &&
        account.authorized_portfolios &&
        !account.authorized_portfolios.includes(selected_portfolio.portfolio_id)
      ) {
        set_portfolio_by_id(null);
        set_account_by_id(null);
        setIsAuthorized(false);
      } else {
        setIsAuthorized(true);
      }
    }
  }, [
    context_state.selected_portfolio,
    context_state.account,
    set_portfolio_by_id,
    set_account_by_id,
  ]);

  return isAuthorized ? (
    children
  ) : (
    <Navigate to="/unauthorized" replace state={{ from: location }} />
  );
};

export default AuthorizedRoute;
